import { render, staticRenderFns } from "./AppToolbarGhost.vue?vue&type=template&id=0c282273&scoped=true"
import script from "./AppToolbarGhost.vue?vue&type=script&lang=js"
export * from "./AppToolbarGhost.vue?vue&type=script&lang=js"
import style0 from "./AppToolbarGhost.vue?vue&type=style&index=0&id=0c282273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c282273",
  null
  
)

export default component.exports